var React = require('react');

function BfLandingBannerArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.93526 0.351341C9.17665 0.148267 9.52913 0.148267 9.77052 0.351341L17.8234 7.12607C18.2865 7.51571 18.011 8.27121 17.4058 8.27121H1.30002C0.694782 8.27121 0.41925 7.51571 0.882394 7.12607L8.93526 0.351341Z"}));
}

BfLandingBannerArrow.defaultProps = {"width":"19","height":"9","viewBox":"0 0 19 9","fill":"none"};

module.exports = BfLandingBannerArrow;

BfLandingBannerArrow.default = BfLandingBannerArrow;
